<template>
  <div>
    <OperatorForm type="update" />
  </div>
</template>

<script>
import OperatorForm from "./OperatorForm.vue";
export default {
  name: "UpdateOperator",
  components: {
    OperatorForm
  }
};
</script>
